import { ActionTypes } from 'redux/utils/Value'

export default ActionTypes('MEDICATION_COUNT')